import type {
  BillingProfile,
  Client,
  Invoice,
  PersistedWorkspace,
} from "./types";

const STORAGE_KEY = "invoice-index.workspace.v1";

export function loadLocalWorkspace(): PersistedWorkspace | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed !== "object" ||
      parsed === null ||
      !("version" in parsed) ||
      parsed.version !== 1
    ) {
      return null;
    }
    return parsed as PersistedWorkspace;
  } catch {
    return null;
  }
}

export function saveLocalWorkspace(workspace: PersistedWorkspace): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(workspace));
}

export function mergeById<T extends { id: string }>(
  values: T[],
  value: T,
): T[] {
  const exists = values.some((entry) => entry.id === value.id);
  return exists
    ? values.map((entry) => (entry.id === value.id ? value : entry))
    : [value, ...values];
}

export interface WorkspaceDataset {
  profiles: BillingProfile[];
  clients: Client[];
  invoices: Invoice[];
}
